export default function formAPIPrescriptions({
    id,
    doctorname,
    specialization,
    doctorimage,
    appointmentid,
    bookingid,
    prescribeddate,
    documents,
    imagepath,
    patientimage,
    patientname,
    chiefcomplaint,
    progessnoteurl,
    audiourl
    
  }) {
   
  
    return Object.freeze({
        id,
        doctorname,
        specialization,
        doctorimage,
        appointmentid,
        bookingid,
        prescribeddate,
        documents,
        imagepath,
        patientimage,
    patientname,
    chiefcomplaint,
    progessnoteurl,
    audiourl
    });
  }
  